<div class="h-screen flex justify-center items-center p-5 ">
  <div class=" border-2 rounded-xl h-full min-h-[800px] min-w-[400px] overflow-scroll flex flex-col p-1 relative">

    @for (component of components(); track component){
      @switch (component.type){
        @case (TypeComponent.TEXT){
          <lib-text [component]="component"></lib-text>
        }
        @case (TypeComponent.IMAGE_BUTTON){
          <lib-button-image [component]="component"></lib-button-image>
        }
        @case (TypeComponent.CARROUSEL){
          <lib-carousel [component]="component"></lib-carousel>
        }
        @case (TypeComponent.IMAGE){
          <lib-image [component]="component"></lib-image>
        }
        @case (TypeComponent.BUTTON){
          <lib-app-button [component]="component"></lib-app-button>
        }
        @case (TypeComponent.VIDEO){
          <lib-video [component]="component"></lib-video>
        }
      }
    }
  </div>
</div>



